import React from 'react';
import { Link } from 'gatsby';
import { getIssueAuthors } from '../../model/author';
import { useWipAuthors } from '../../hooks/use-wip-authors';
import { getIssuePath } from '../../model/post';
import { GatsbyImage } from 'gatsby-plugin-image';
import IssuesAuthorLink from './author-link';

const Card = ({ issue, showFeaturesBar }) => {
  const {
    name,
    slug,
    posts: { nodes: issuePosts },
    tghpwipIssuesTaxonomyFeaturedImage: issueImage,
    tghpwipIssuesTaxonomyColor: themeColor,
  } = issue;

  const allAuthors = useWipAuthors();
  const postAuthors = getIssueAuthors(issuePosts, allAuthors);
  const issuePath = getIssuePath(slug);

  return (
    <div className={`issue-card issue-card--color-${themeColor}`}>
      <Link to={issuePath} className="issue-card__title-bar">
        <h1 className="issue-card__title-bar-text">{name}</h1>
      </Link>
      <Link to={issuePath} className="issue-card__image">
        {issueImage?.nodes.length > 0 && (
          <GatsbyImage
            image={issueImage?.nodes[0]?.gatsbyImage}
            sizes="(min-width: 720px) 60vw, 50vw"
            alt=""
          />
        )}
      </Link>
      {showFeaturesBar && (
        <>
          <Link to={issuePath} className="issue-card__link">
            View all articles
          </Link>
          <div className="issue-card__featuring">
            <div className="issue-card__featuring-title">Featuring</div>
            <div className="issue-card__featuring-authors">
              {postAuthors.slice(0, 12).map((author, idx) => (
                <IssuesAuthorLink author={author} key={idx} issuesPage={true} />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Card;
